import React, { useState } from "react";
import { Link } from "react-router-dom";
import { INewsEventsData } from "../../exports/interfaces";
import { useMobile } from "../../hooks/custom/useMobile";
import useTab from "../../hooks/custom/useTab";
import { useTabs } from "../../hooks/lib/useTabs";
import { stripHtml } from "../../exports/functions";
import { PdfViwer } from "../PdfViwer";

const getNoticeRedirectUrl = (post: INewsEventsData) => {
  const pdfUrl = post.file?.[0]?.media?.url;
  if (post.title === "Call for Expression of Interest")
    return "/announcement/eoi";
  if (post.title === "Competition for Logo Design")
    return "/announcement/logoCompetition";
  if (post.title === "घर जग्गा भाडामा दिने प्रस्ताव आह्वान")
    return "/announcement/landLease";
  if (post.title === "विश्वविद्यालयको शैक्षिक कार्यक्रम सुरु")
    return "/announcement/mpp";
  if (post.title === "Admission Open Now for MPP")
    return "/announcement/admissionOpen";
  return pdfUrl ? "#" : stripHtml(post.link);
};

const renderTableRows = (
  posts: INewsEventsData[],
  openPdf: (path: string) => void,
) =>
  posts.length ? (
    posts.map((post) => {
      const pdfUrl = post.file?.[0]?.media?.url;
      const redirectUrl = getNoticeRedirectUrl(post);
      const isInternal =
        post.title === "Academic Post" ||
        post.title === "Admin Post" ||
        redirectUrl.startsWith("/announcement/");

      return (
        <tr key={`${post.title}-${post.date}`}>
          <td>
            <p className="td_fs_16 td_heading_color">{post.date || "N/A"}</p>
          </td>
          <td>
            <p className="td_heading_color td_fs_18 td_medium mb-2">
              {post.title}
            </p>
            <p className="td_post_subtitle td_heading_color td_opacity_7 mb-0">
              {post.sub_title}
            </p>
          </td>
          {/* <td className="td_fs_16 td_heading_color">
            {post.category || "Others"}
          </td> */}
          <td>
            {pdfUrl ? (
              <button
                type="button"
                className="td_btn td_style_1 td_type_3 td_radius_30 td_medium"
                onClick={() => openPdf(pdfUrl)}
                style={{ backgroundColor: "white", width: "130px" }}
              >
                <span className="td_btn_in td_accent_color">
                  <span>Read More</span>
                </span>
              </button>
            ) : (
              <Link
                to={redirectUrl}
                target={isInternal ? "_self" : "_blank"}
                rel={isInternal ? undefined : "noopener noreferrer"}
                className="td_btn td_style_1 td_type_3 td_radius_30 td_medium"
                style={{ backgroundColor: "white", width: "130px" }}
              >
                <span className="td_btn_in td_accent_color">
                  <span>Read More</span>
                </span>
              </Link>
            )}
          </td>
        </tr>
      );
    })
  ) : (
    <tr>
      <td colSpan={4} className="td_fs_16 td_heading_color text-center py-4">
        No public notices found.
      </td>
    </tr>
  );

export const NewsEvents = (props: { newsEvents: INewsEventsData[] }) => {
  useTabs();
  const mobile = useMobile();
  const tab = useTab();
  const [openPdf, setOpenPdf] = useState(false);
  const [pdfPath, setPdfPath] = useState("");

  const categories = [
    { label: "Admission", id: "notice_tab_6", category: "Admission" },
    { label: "Vacancy", id: "notice_tab_2", category: "Vacancy" },
    { label: "Procurement", id: "notice_tab_3", category: "Procurement" },
    {
      label: "Expression of Interest",
      id: "notice_tab_4",
      category: "Expression of Interest",
    },
    { label: "Others", id: "notice_tab_5", category: "" },
  ];

  const hasPosts = (category: string) =>
    category === "Vacancy"
      ? true
      : category
        ? props.newsEvents.some((post) => post.category === category)
        : props.newsEvents.some((post) => !post.category);

  const tabStyle = {
    width: mobile || tab ? "100%" : "unset",
    display: mobile || tab ? "flex" : "block",
    justifyContent: "center",
  };

  const vacancyTiles: INewsEventsData[] = [
    {
      title: "Academic Post",
      sub_title: "Vacancies open for academic posts",
      date: "May 12, 2026",
      file: [],
      thumbnail: [],
      link: "/vacancy#academic",
      category: "",
    } as INewsEventsData,
    {
      title: "Admin Post",
      sub_title: "Vacancies open for admin posts",
      date: "May 12, 2026",
      file: [],
      thumbnail: [],
      link: "/vacancy#admin",
      category: "",
    } as INewsEventsData,
  ];

  const openViewer = (path: string) => {
    setPdfPath(path);
    setOpenPdf(true);
  };

  const renderMobileList = (posts: INewsEventsData[]) => (
    <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
      {posts.length ? (
        posts.map((post) => {
          const pdfUrl = post.file?.[0]?.media?.url;
          const redirectUrl = getNoticeRedirectUrl(post);
          const isInternal =
            post.title === "Academic Post" ||
            post.title === "Admin Post" ||
            redirectUrl.startsWith("/announcement/");

          return (
            <div className="td_post td_style_1">
              <div
                key={`${post.title}-${post.date}`}
                className="td_post_info"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "12px",
                }}
              >
                <p className="td_fs_16 td_heading_color mb-0">
                  {post.date || "N/A"}
                </p>

                <p className="td_heading_color td_fs_18 td_medium mb-0">
                  {post.title}
                </p>
                <p className="td_post_subtitle td_heading_color td_opacity_7 mb-0">
                  {post.sub_title}
                </p>

                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  {pdfUrl ? (
                    <button
                      type="button"
                      className="td_btn td_style_1 td_type_3 td_radius_30 td_medium"
                      onClick={() => openViewer(pdfUrl)}
                      style={{
                        backgroundColor: "white",
                        width: "130px",
                      }}
                    >
                      <span className="td_btn_in td_accent_color">
                        <span>Read More</span>
                      </span>
                    </button>
                  ) : (
                    <Link
                      to={redirectUrl}
                      target={isInternal ? "_self" : "_blank"}
                      rel={isInternal ? undefined : "noopener noreferrer"}
                      className="td_btn td_style_1 td_type_3 td_radius_30 td_medium"
                      style={{
                        backgroundColor: "white",
                        width: "130px",
                        // display: "inline-flex",
                        // justifyContent: "center",
                      }}
                    >
                      <span className="td_btn_in td_accent_color">
                        <span>Read More</span>
                      </span>
                    </Link>
                  )}
                </div>
              </div>
            </div>
          );
        })
      ) : (
        <div
          style={{
            textAlign: "center",
            padding: "20px 0",
            color: "#333",
          }}
        >
          No public notices found.
        </div>
      )}
    </div>
  );

  const renderTabTable = (posts: INewsEventsData[]) => {
    if (mobile) {
      return renderMobileList(posts);
    }

    return (
      <div className="table-responsive">
        <table className="table td_table_1 public-notice-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Notice</th>
              {/* <th>Category</th> */}
              {/* <th>Action</th> */}
            </tr>
          </thead>
          <tbody>{renderTableRows(posts, openViewer)}</tbody>
        </table>
      </div>
    );
  };

  return (
    <section id="news-events">
      <div className="td_height_112 td_height_lg_40" />
      <div className="container">
        <div
          className="td_section_heading td_style_1 text-center wow fadeInUp"
          data-wow-duration="1s"
          data-wow-delay="0.2s"
        >
          <h2 className="td_section_title td_fs_48 mb-0">Public Notice</h2>
        </div>

        <div className="td_height_30 td_height_lg_30" />

        <div className="td_notice_tabs">
          <ul
            className="td_tab_links td_style_1 td_mp_0 td_fs_20 td_medium td_heading_color wow fadeInUp"
            data-wow-duration="1s"
            data-wow-delay="0.2s"
          >
            <li
              className="active"
              style={{ width: mobile || tab ? "100%" : "unset" }}
            >
              <a
                href="#notice_tab_1"
                style={{
                  width: mobile || tab ? "100%" : "unset",
                  display: mobile || tab ? "flex" : "block",
                  justifyContent: "center",
                }}
              >
                All
              </a>
            </li>
            {categories.map(({ label, id, category }) => {
              const enabled = hasPosts(category);
              return (
                <li
                  key={id}
                  style={{ width: mobile || tab ? "100%" : "unset" }}
                >
                  <a
                    href={`#${id}`}
                    className={!enabled ? "disabled" : ""}
                    aria-disabled={!enabled}
                    style={{
                      ...tabStyle,
                      opacity: enabled ? 1 : 0.45,
                      pointerEvents: enabled ? "auto" : "none",
                    }}
                  >
                    {label}
                  </a>
                </li>
              );
            })}
          </ul>

          <div className="td_height_30 td_height_lg_30" />

          <div className="td_tab_body">
            <div className="td_tab active" id="notice_tab_1">
              {renderTabTable(props.newsEvents)}
            </div>
            <div className="td_tab" id="notice_tab_6">
              {renderTabTable(
                props.newsEvents.filter(
                  (post) => post.category === "Admission",
                ),
              )}
            </div>
            <div className="td_tab" id="notice_tab_2">
              {renderTabTable(
                props.newsEvents
                  .filter((post) => post.category === "Vacancy")
                  .concat(vacancyTiles),
              )}
            </div>
            <div className="td_tab" id="notice_tab_3">
              {renderTabTable(
                props.newsEvents.filter(
                  (post) => post.category === "Procurement",
                ),
              )}
            </div>
            <div className="td_tab" id="notice_tab_4">
              {renderTabTable(
                props.newsEvents.filter(
                  (post) => post.category === "Expression of Interest",
                ),
              )}
            </div>
            <div className="td_tab" id="notice_tab_5">
              {renderTabTable(
                props.newsEvents.filter((post) => !post.category),
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="td_height_120 td_height_lg_40" />
      <PdfViwer
        open={openPdf}
        onClose={() => setOpenPdf(false)}
        path={pdfPath}
      />
    </section>
  );
};
